import LandingPage from "../components/landing-page/LandingPage";

export default {
  name: "Landing Page",
  component: LandingPage,
  url: "/",
  exact: true,
  requireAuth: false
};
